var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    {
      directives: [
        {
          name: "loading",
          rawName: "v-loading",
          value: _vm.loading,
          expression: "loading"
        }
      ],
      staticClass: "grid-view",
      attrs: {
        "element-loading-text": "Loading...",
        "element-loading-spinner": "el-icon-loading",
        "element-loading-background": "rgba(170,170,170,0.5)"
      }
    },
    [
      _c(
        "div",
        { staticClass: "main-content" },
        [
          _c("div", { staticClass: "section operations" }, [
            _c("div", { staticClass: "triggers" }, [
              _c(
                "div",
                { staticStyle: { display: "inline-block" } },
                [
                  _c(
                    "el-button",
                    {
                      attrs: { type: "primary" },
                      on: {
                        click: function($event) {
                          return _vm.queryJobs()
                        }
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("CargoMsg.Cargo_Refresh")))]
                  ),
                  _c(
                    "el-checkbox",
                    {
                      staticStyle: { margin: "0 5px" },
                      on: { change: _vm.resetTimer },
                      model: {
                        value: _vm.autoRefresh,
                        callback: function($$v) {
                          _vm.autoRefresh = $$v
                        },
                        expression: "autoRefresh"
                      }
                    },
                    [_vm._v(_vm._s(_vm.$t("SeaExport.AutomaticallyRefresh")))]
                  )
                ],
                1
              )
            ])
          ]),
          _c("cargo-ag-grid", {
            staticClass: "section grid-wrapper",
            attrs: {
              "grid-options": _vm.gridOptions,
              "column-defs": _vm.columnDefs,
              "row-data": _vm.rowData
            },
            on: {
              gridReady: function(params) {
                _vm.gridApi = params.api
              }
            }
          })
        ],
        1
      )
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }